module.exports = __webpack_public_path__ + "static/media/hook-lift.7456671c.svg";